import { graphql } from 'react-relay';

export const fundsListPageFragment = graphql`
  fragment FundsListPage_page on FundsListPage
  @argumentDefinitions(
      salesAdmission: {type: "String!"}
  ) {
      components(first: 1000) {
        edges {
          node {
            __typename
            ...FundsSelection_component
            ...Widget_component @arguments(salesAdmission: $salesAdmission)
          }
        }
      }
      breadcrumbs {
        ...Breadcrumb_data
      }
      path
      id
  }
`;
